export default "__VITE_ASSET__nS1rf9Qb__"